import { Component, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutService } from '../../core/services/layout.service';
import { IconComponent } from '../icons/icon.component';
import { IconNameType } from '../icons/icon-name-type.enum';
import { TranslocoPipe } from '@ngneat/transloco';
import { ModalService } from '../../core/services/modal.service';

@Component({
  selector: 'cwo-view-order-button',
  standalone: true,
  imports: [CommonModule, IconComponent, TranslocoPipe],
  templateUrl: './view-order-button.component.html',
  styleUrl: './view-order-button.component.scss',
})
export class ViewOrderButtonComponent {
  layout = inject(LayoutService);
  modalService = inject(ModalService);

  iconNameType = IconNameType;

  fullWidth = input<boolean>(false);
  cartNumber = input<number>(0);
  itemCount = input<number>(0);
}
